"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var companyApi = _interopRequireWildcard(require("@/api/companyApi.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      addresData: [],
      pram: {}
    };
  },
  props: {
    editId: [Number, String]
  },
  watch: {
    editId: {
      handler: function handler(editId) {
        if (!editId) {
          this.initParams();
          return;
        }
        ;
        this.getDetail(editId);
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    initParams: function initParams() {
      this.pram = {
        name: '',
        taxId: '',
        addressId: [],
        address: '',
        status: 1,
        remark: ''
      };
    },
    getDetail: function getDetail(id) {
      var _this = this;
      this.initParams();
      companyApi.getComDetail(id).then(function (res) {
        var _ref = res || {},
          name = _ref.name,
          taxId = _ref.taxId,
          id = _ref.id,
          provinceId = _ref.provinceId,
          cityId = _ref.cityId,
          districtId = _ref.districtId,
          address = _ref.address,
          status = _ref.status,
          remark = _ref.remark;
        _this.pram = {
          name: name,
          taxId: taxId,
          id: id,
          addressId: [provinceId, cityId, districtId],
          address: address,
          status: status,
          remark: remark
        };
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        companyApi[_this2.editId ? 'UpdateArticle' : 'AddArticle'](_this2.pram).then(function (data) {
          _this2.$message.success('编辑成功');
          _this2.loading = false;
          _this2.closeEdit();
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    getCityList: function getCityList() {
      var _this3 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this3.addresData = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    },
    closeEdit: function closeEdit() {
      this.$emit('hideDialog');
    },
    cancelEdit: function cancelEdit() {
      this.$emit('closeEdit');
    }
  }
};